<template>
    <div>
        <div class="app-heading" :class="globalClassName">
            <div class="app-heading__heading-container">
                <slot name="main-heading">
                    <h2 class="app-heading__heading" :class="mainTitleClass" v-html="mainTitle"></h2>
                </slot>
                <slot name="sub-heading">
                    <p class="app-heading__subheading" :class="subTitle" v-html="subTitle"></p>
                </slot>
            </div>
            <div class="app-heading__misc-container">
                <slot name="misc">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        mainTitle: {
            type: String,
            default: "Titre Principal"
        },
        mainTitleClass: {
            type: String,
            default: "Sous-Titre"
        },
        subTitle: {
            type: String,
            default: ""
        },
        subtitleClass: {
            type: String,
            default: ""
        },
        globalClassName: {
            type: [String, Array],
            default: ""
        }
    }
}
</script>

<style lang="scss">
.app-heading {
  position: relative;
  text-align: center;

  .app-heading__heading-container {
    position: relative;
    margin-top: 3.5rem;
    margin-bottom: 6rem;

    .app-heading__heading {
      position: relative;
      display: inline-block;
      color: #333;
      font-size: 3rem;
      letter-spacing: 3.5px;
      font-weight: 500;
      text-transform: uppercase;
      width:"auto";
      height: "auto";
      margin-bottom: 30px;
      // background-color: red;

      &::before {
        content:" ";
        display: block;
        position: absolute;
        height: 4px;
        width: 30%;
        background-color: darken(#05bdff, 30%);
        bottom: -10px;
        left: 50%;
        transform: translate(-50%);
      }
    }

    .app-heading__subheading {
      color: grey;
      font-weight: 400;
      font-size: 1.4rem;
      text-transform: uppercase;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/AppHeading.vue